/* unplugin-vue-components disabled */import script from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"

import "./MainLayout.vue?vue&type=style&index=0&id=19210518&lang=scss&scoped=true"

import exportComponent from "/Users/zouchanghua/Documents/project/xrverse/xrweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19210518"]])

export default __exports__